import React, { useContext } from "react";
import classNames from "classnames";
import GlobalContext from "../../context/global";

const ButtonBack = ({
  onClick = () => history.back(),
  caption = "Back",
  id = "back-button",
  tabIndex = 0,
  dataTestId = "back-button",
  className = "col-6",
}) => {
  const appData = useContext(GlobalContext);
  const {
    dealerProfile: {
      isCDTT,
      product,
      template,
      dealerStyle: { primaryColor },
    },
  } = appData;
  const isCredit = product === "credit" && template === "carAndDriverCredit";

  return (
    <div className={classNames(className, { "m-sm-0 my-4": isCDTT })}>
      <button
        id={id}
        className={classNames("btn btn-lg w-100 fw-bold", {
          "btn-default btn-back": primaryColor,
          "rounded rounded-1 text-uppercase": isCDTT,
          "btn-dark": !isCredit && !primaryColor,
          "btn-back--credit": isCredit,
        })}
        onClick={onClick}
        tabIndex={tabIndex}
        data-testid={dataTestId}
      >
        {caption}
      </button>
    </div>
  );
};

export default ButtonBack;
